// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--FundingPanel-module--fundingCard--n5qzz8CbEPpmHMWeab0S {
  margin-bottom: 24px;
}

.zappyride_incentive_web--FundingPanel-module--read-only-section--hi8ekRbSyZBlU7exIbdw {
  row-gap: 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Funding/FundingPanel.module.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AACA;EACI,aAAA;AAEJ","sourcesContent":[".fundingCard {\n    margin-bottom: 24px;\n}\n.read-only-section {\n    row-gap: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fundingCard": `zappyride_incentive_web--FundingPanel-module--fundingCard--n5qzz8CbEPpmHMWeab0S`,
	"read-only-section": `zappyride_incentive_web--FundingPanel-module--read-only-section--hi8ekRbSyZBlU7exIbdw`
};
export default ___CSS_LOADER_EXPORT___;
